import { useSubscriberChange } from "@/services/data";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

export default function SubscriberChangeContainer() {
  const { data, isLoading } = useSubscriberChange();

  const columns = [
    { field: "date", headerName: "Date", width: 100 },
    {
      field: "subscribed",
      headerName: "+",
      width: 60,
      align: "center",
      valueFormatter: (value) => (value > 0 ? `+${value}` : value),
      cellClassName: (params) => {
        if (params.value == 0) {
          return "is-zero";
        }
      },
    },
    {
      field: "expired",
      headerName: "-",
      width: 60,
      align: "center",
      cellClassName: (params) => {
        if (params.value == 0) {
          return "is-zero";
        }
      },
    },
    {
      field: "Total",
      headerName: "Active Subscribers",
      width: 120,
      align: "center",
    },
  ];

  return (
    <Box
      sx={{
        mb: 4,
        "& .is-zero": {
          color: "#4E4B4B",
        },
      }}
    >
      <DataGrid
        rows={data}
        columns={columns}
        getRowId={(row) => row.date}
        pagination
        pageSizeOptions={[5, 10, 20]}
        initialState={{
          sorting: { sortModel: [{ field: "date", sort: "desc" }] },
          pagination: { paginationModel: { pageSize: 5 } },
        }}
      />
    </Box>
  );
}
